import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject4(): Promise<void> {
  await Excel.run(async (ctx) => {
    // ═══ HOJA 1 – Departamento de Ventas ═══
    await safeDeleteSheet(ctx, "Departamento de Ventas");
    const sh3 = ctx.workbook.worksheets.add("Departamento de Ventas");

    const rowsVentas: (string | number)[][] = [
      ["Apellido", "Nombre", "Dirección de Email"],
      ["Hart", "Sam", ""],
      ["Finney", "Mike", ""],
      ["Barlow", "Kevin", ""],
      ["Noakes", "Sheila", ""],
      ["Riley", "Steve", ""],
      ["Webster", "Dan", ""],
      ["Moorefield", "Eva", ""],
      ["Doran", "John", ""],
      ["Flint", "Cheryl", ""],
      ["Shea", "Jessie", ""],
      ["Oppenhoff", "Greg", ""],
      ["Cramer", "Chris", ""],
      ["Silman", "Stan", ""],
      ["Franklin", "DeAnn", ""],
      ["Nguen", "Yuan", ""],
      ["Gbedemah", "Kofi", ""],
      ["Juarez", "Juanita", ""],
      ["Sanchez", "Timo", ""],
      ["Braun", "Christof", ""],
      ["Perez", "Bridgette", ""],
      ["Bahn", "Chris", ""],
      ["Stephan", "Pierre", ""],
      ["Yamashita", "Jan", ""],
      ["White", "Brent", ""],
      ["Brown", "Samuel", ""],
      ["Chu", "Jen", ""],
      ["Martinez", "Rosie", ""],
      ["LaRose", "Haley", ""],
      ["Kramer", "Logan", ""],
      ["Watson", "Von", ""],
      ["Doucette", "Nicole", ""],
      ["Clauss", "Nickaus", ""],
    ];
    sh3.getRangeByIndexes(1, 0, rowsVentas.length, 3).values = rowsVentas;

    sh3.getRange("A1:C1").merge();
    sh3.getRange("A1").values = [["Departamento de Ventas"]];
    sh3.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 16 },
    });

    const tblVentas = sh3.tables.add("A2:C34", true);
    tblVentas.style = "TableStyleMedium2";

    sh3.getUsedRange().format.autofitColumns();
    sh3.activate();

    // ═══ HOJA 2 – Calculadora de Envío ═══
    await safeDeleteSheet(ctx, "Calculadora de Envío");
    const shCE = ctx.workbook.worksheets.add("Calculadora de Envío");

    shCE.getRange("A1:B1").merge();
    shCE.getRange("A1").values = [["Calculadora de Envío"]];
    shCE.getRange("A1").format.set({
      horizontalAlignment: "Center",
      font: { bold: true, size: 24, color: "#9c7a28" },
    });

    shCE.getRange("A2").values = [["Descripción"]];
    shCE.getRange("B2").values = [["Fecha"]];
    shCE.getRange("A2:B2").format.set({
      font: { bold: true, color: "white" },
      fill: { color: "#c9a14d" },
      horizontalAlignment: "Center",
    });

    shCE.getRange("A3:A6").values = [
      ["Fecha de Salida del Envío:"],
      ["Longitud de Envío (días hábiles)"],
      ["Días de Fin de Semana Transitorios"],
      ["Fecha de Llegada Estimada:"],
    ];
    shCE.getRange("B4:B6").values = [[4], [2], [""]];
    shCE.getRange("B3").formulas = [["=DATE(2025,4,25)"]];
    shCE.getRange("B3").numberFormat = [["dd/mm/yyyy"]];
    shCE.getRange("B4:B5").numberFormat = [["0"]];

    const boxCE = shCE.getRange("A2:B6").format.borders;
    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = boxCE.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    shCE.getUsedRange().format.autofitColumns();

    // ═══ HOJA 3 – Calculadora de Pago ═══
    await safeDeleteSheet(ctx, "Calculadora de Pago");
    const shPay = ctx.workbook.worksheets.add("Calculadora de Pago");

    const texto: (string | number)[][] = [
      ["Descripción", "Fecha"],
      ["Monto del Préstamo:", 50000],
      ["Tasa de Interés:", 0.05],
      ["Mensualidad:", 500],
      ["Períodos Compuestos por Año:", 12],
      ["", ""],
      ["Períodos (meses) para pagar el préstamo", ""],
    ];
    shPay.getRange("A2:B8").values = texto;

    shPay.getRange("A1:B1").merge();
    shPay.getRange("A1").values = [["Calculadora de Pago"]];
    shPay.getRange("A1").format.set({
      font: { bold: true, size: 18 },
      horizontalAlignment: "Center",
    });

    shPay.getRange("A2:B2").format.fill.color = "#d2a86d";
    shPay.getRange("A2:B2").format.font.bold = true;

    // Bordes A2:B6
    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = shPay.getRange("A2:B6").format.borders.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    // Bordes A8:B8
    (
      [
        "EdgeTop",
        "EdgeBottom",
        "EdgeLeft",
        "EdgeRight",
        "InsideHorizontal",
        "InsideVertical",
      ] as const
    ).forEach((id) => {
      const b = shPay.getRange("A8:B8").format.borders.getItem(id);
      b.style = "Continuous";
      b.weight = "Thin";
      b.color = "#000000";
    });

    shPay.getRange("B3").numberFormat = [["$#,##0.00"]];
    shPay.getRange("B5").numberFormat = [["$#,##0.00"]];
    shPay.getRange("B4").numberFormat = [["0%"]];
    shPay.getRange("B6").numberFormat = [["0"]];

    shPay.getUsedRange().format.autofitColumns();

    // ═══ HOJA 4 – Exportaciones de Grano ═══
    await safeDeleteSheet(ctx, "Exportaciones de Grano");
    const shgranos = ctx.workbook.worksheets.add("Exportaciones de Grano");

    const datos: (string | number)[][] = [
      [
        "Código País",
        "País",
        "Código Producto",
        "Producto",
        "Año",
        "Toneladas métricas",
      ],
      [21, "Brasil", 44, "Cebada", 2024, 265025],
      [21, "Brasil", 44, "Cebada", 2025, 330682],
      [21, "Brasil", 44, "Cebada", 2026, 251539],
      [21, "Brasil", 56, "Maíz", 2024, 71072810],
      [21, "Brasil", 56, "Maíz", 2025, 80273172],
      [21, "Brasil", 56, "Maíz", 2026, 79877714],
      [21, "Brasil", 75, "Avena", 2024, 431024],
      [21, "Brasil", 75, "Avena", 2025, 520397],
      [21, "Brasil", 75, "Avena", 2026, 432136],
      [21, "Brasil", 27, "Arroz", 2024, 11549881],
      [21, "Brasil", 27, "Arroz", 2025, 11782549],
      [21, "Brasil", 27, "Arroz", 2026, 12175602],
      [21, "Brasil", 15, "Trigo", 2024, 4418388],
      [21, "Brasil", 15, "Trigo", 2025, 5738473],
      [21, "Brasil", 15, "Trigo", 2026, 6261895],
      [33, "Canadá", 44, "Cebada", 2024, 8012300],
      [33, "Canadá", 44, "Cebada", 2025, 10237100],
      [33, "Canadá", 44, "Cebada", 2026, 7119000],
      [33, "Canadá", 56, "Maíz", 2024, 13060100],
      [33, "Canadá", 56, "Maíz", 2025, 14193800],
      [33, "Canadá", 56, "Maíz", 2026, 11486800],
      [33, "Canadá", 75, "Avena", 2024, 2811900],
      [33, "Canadá", 75, "Avena", 2025, 3905600],
      [33, "Canadá", 75, "Avena", 2026, 2907000],
      [33, "Canadá", 15, "Trigo", 2024, 27205200],
      [33, "Canadá", 15, "Trigo", 2025, 37529600],
      [33, "Canadá", 15, "Trigo", 2026, 29280800],
      [100, "India", 44, "Cebada", 2024, 1620000],
      [100, "India", 44, "Cebada", 2025, 1750000],
      [100, "India", 44, "Cebada", 2026, 1830000],
      [100, "India", 56, "Maíz", 2024, 22260000],
      [100, "India", 56, "Maíz", 2025, 23290000],
      [100, "India", 56, "Maíz", 2026, 23670000],
      [100, "India", 27, "Arroz", 2024, 157800000],
      [100, "India", 27, "Arroz", 2025, 159200000],
      [100, "India", 27, "Arroz", 2026, 157200000],
      [100, "India", 15, "Trigo", 2024, 94880000],
      [100, "India", 15, "Trigo", 2025, 93510000],
      [100, "India", 15, "Trigo", 2026, 94483000],
      [185, "Rusia", 44, "Cebada", 2024, 13951676],
      [185, "Rusia", 44, "Cebada", 2025, 15388704],
      [185, "Rusia", 44, "Cebada", 2026, 20444258],
      [185, "Rusia", 56, "Maíz", 2024, 8212924],
      [185, "Rusia", 56, "Maíz", 2025, 11634943],
      [185, "Rusia", 56, "Maíz", 2026, 11332138],
      [185, "Rusia", 75, "Avena", 2024, 4027274],
      [185, "Rusia", 75, "Avena", 2025, 4931822],
      [185, "Rusia", 75, "Avena", 2026, 5273812],
      [185, "Rusia", 27, "Arroz", 2024, 1051891],
      [185, "Rusia", 27, "Arroz", 2025, 934943],
      [185, "Rusia", 27, "Arroz", 2026, 1048566],
      [185, "Rusia", 15, "Trigo", 2024, 37719640],
      [185, "Rusia", 15, "Trigo", 2025, 52090796],
      [185, "Rusia", 15, "Trigo", 2026, 59711382],
      [231, "Estados Unidos", 44, "Cebada", 2024, 4796081],
      [231, "Estados Unidos", 44, "Cebada", 2025, 4682735],
      [231, "Estados Unidos", 44, "Cebada", 2026, 3849230],
      [231, "Estados Unidos", 56, "Maíz", 2024, 273820066],
      [231, "Estados Unidos", 56, "Maíz", 2025, 353699441],
      [231, "Estados Unidos", 56, "Maíz", 2026, 361091140],
      [231, "Estados Unidos", 75, "Avena", 2024, 987415],
      [231, "Estados Unidos", 75, "Avena", 2025, 1016024],
      [231, "Estados Unidos", 75, "Avena", 2026, 1011460],
      [231, "Estados Unidos", 27, "Arroz", 2024, 9051265],
      [231, "Estados Unidos", 27, "Arroz", 2025, 8613094],
      [231, "Estados Unidos", 27, "Arroz", 2026, 10025980],
      [231, "Estados Unidos", 15, "Trigo", 2024, 61677384],
      [231, "Estados Unidos", 15, "Trigo", 2025, 57966656],
      [231, "Estados Unidos", 15, "Trigo", 2026, 55395400],
      [351, "China", 44, "Cebada", 2024, 1625800],
      [351, "China", 44, "Cebada", 2025, 1699300],
      [351, "China", 44, "Cebada", 2026, 1706000],
      [351, "China", 56, "Maíz", 2024, 205719284],
      [351, "China", 56, "Maíz", 2025, 218621905],
      [351, "China", 56, "Maíz", 2026, 215812100],
      [351, "China", 75, "Avena", 2024, 650000],
      [351, "China", 75, "Avena", 2025, 600000],
      [351, "China", 75, "Avena", 2026, 630000],
      [351, "China", 27, "Arroz", 2024, 205936129],
      [351, "China", 27, "Arroz", 2025, 205201696],
      [351, "China", 27, "Arroz", 2026, 208239610],
      [351, "China", 15, "Trigo", 2024, 121030059],
      [351, "China", 15, "Trigo", 2025, 121930527],
      [351, "China", 15, "Trigo", 2026, 126212750],
    ];

    shgranos.getRangeByIndexes(0, 0, datos.length, 6).values = datos;

    const tbl = shgranos.tables.add(
      shgranos.getRangeByIndexes(0, 0, datos.length, 6),
      true
    );
    tbl.name = "Granos";
    tbl.style = "TableStyleMedium4";

    shgranos.getRange(`F2:F${datos.length}`).numberFormat = [["#,##0"]];

    shgranos.getUsedRange().format.autofitColumns();
    shgranos.activate();

    await ctx.sync();
  });
}
